import { fetchClient } from "@/api/api";

/**
 * Everything `useFacets` needs to talk to one facets endpoint: how to key its
 * cache entries and how to fetch a given filter combination.
 */
export type FacetSource<TFacets> = {
	queryKey: (query: Record<string, unknown>) => string[];
	fetch: (query: Record<string, unknown>) => Promise<TFacets>;
};

export function createFacetSource<TFacets, TRaw = TFacets>(args: {
	path: string;
	queryKey: (query: Record<string, unknown>) => string[];
	/** Reshapes the raw response, e.g. unwrapping `{ with_filter }` counts. */
	select?: (raw: TRaw) => TFacets;
}): FacetSource<TFacets> {
	return {
		queryKey: args.queryKey,
		fetch: async (query) => {
			// openapi-fetch cannot infer a generic path literal; TFacets is supplied
			// by the service declaring the source.
			const { data, error } = await (fetchClient.GET as any)(args.path, {
				params: { query },
				throwOnError: true,
			});
			if (error) throw error;
			return args.select ? args.select(data as TRaw) : (data as TFacets);
		},
	};
}
